export default "<div>\n\n        <p *ngFor=\"let g of t\">\n    {{g}}\n        </p>\n</div>"